import _classCallCheck from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dstein/dev/jaxcore/spin-a-sketch/node_modules/@babel/runtime/helpers/esm/inherits";
// The object previously known as Client (minus bindInterface)
import EventEmitter from 'events';

var CollectionModel =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(CollectionModel, _EventEmitter);

  function CollectionModel() {
    _classCallCheck(this, CollectionModel);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollectionModel).apply(this, arguments));
  }

  _createClass(CollectionModel, [{
    key: "setStore",
    value: function setStore(store, singleton) {
      if (singleton) {
        this.store = null;
        this.state = store;
      } else {
        this.store = store;
      }
    }
  }, {
    key: "setState",
    value: function setState(data) {
      if (typeof arguments[0] === 'string') {
        var type = arguments[0];
        data = arguments[1];
        var d = Object.assign({}, this.state[type]);
        this.state[type] = d;
        var changes = {};
        changes[type] = {};

        for (var name in data) {
          if (d[name] !== data[name]) {
            d[name] = data[name];
            changes[type][name] = data[name];
          }
        }

        return changes;
      } else {
        if (this.store) {
          var id = this.state ? this.state.id : data.id;
          var changes = this.store.set(id, data);
          this.state = this.store[id];
          this.emit('update', changes);
          return changes;
        } else {
          return this._setState(data);
        }
      }
    }
  }, {
    key: "_setState",
    value: function _setState(data) {
      var changes = {};
      var hasChanges = false;
      var s = this.state;

      for (var i in data) {
        if (typeof data[i] === 'object' || s[i] !== data[i]) {
          hasChanges = true;
          changes[i] = data[i];
          this.state[i] = data[i];
        }
      }

      if (hasChanges) {
        //this.state = Object.assign({}, this.state, changes);
        //console.log('emit update', changes);
        // this.emit('update', this.state, changes);
        this.emit('update', changes);
        return changes;
      } else {
        //if (callback) callback();
        return null;
      }
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.state.id in this.store ? this.store[this.state.id] : {};
    }
  }]);

  return CollectionModel;
}(EventEmitter);

export default CollectionModel;